<div class="dialog-header">
  <h2>Irreversible Action!</h2>
  <ng-icon name="heroXMark" mat-dialog-close class="cursor-pointer"></ng-icon>
</div>
<mat-divider></mat-divider>
<mat-dialog-content>Are you sure you want to delete?</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close color="primary" class="outlined-btn">No</button>
  <button mat-raised-button color="accent" (click)="confirmDelete()">Yes</button>
</mat-dialog-actions>